import { useEffect, useState, useCallback } from 'react';
import api from '../../../../services/api';

export function useWorkCategories(modularUnitId, enabled = true) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCategories = useCallback(async () => {
    if (!modularUnitId) return;
    try {
      setLoading(true);
      setError(null);
      const res = await api.get(`/modular-units/${modularUnitId}/work-categories`);
      if (process.env.NODE_ENV === 'development') {
        console.log('[useWorkCategories] response for', modularUnitId, ':', res.data);
      }
      const payload = res?.data;
      const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.items)
        ? payload.items
        : Array.isArray(payload?.result)
        ? payload.result
        : Array.isArray(payload?.workCategories)
        ? payload.workCategories
        : [];
      setCategories(list);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [modularUnitId]);

  useEffect(() => {
    if (enabled) {
      fetchCategories();
    }
  }, [enabled, fetchCategories]);

  return { categories, loading, error, refresh: fetchCategories };
}
